import { createBrowserRouter, RouterProvider, Outlet, Navigate, useSearchParams } from 'react-router'
import Brand from '@/elements/Brand'
import Profile from '@/pages/Profile'
import Login from '@/pages/Login'
import AuthSetup from '@/pages/AuthSetup'
import ErrorFallback from '@/components/ErrorFallback'
import ResetPassword from '@/pages/ResetPassword'
import SetPassword from '@/pages/SetPassword'

const LoggedOutWrapperWithLogo = () => (
  <main className='container single'>
    <Brand styles={{ margin: '0 auto' }} />
    <Outlet />
  </main>
)

function RequireInviteToken() {
  const [params] = useSearchParams()
  if (!params.get('invite_token')) return <Navigate replace to='/' />
  return <AuthSetup />
}

const loggedOutRouter = createBrowserRouter([
  {
    element: <LoggedOutWrapperWithLogo />,
    ErrorBoundary: ErrorFallback,
    children: [
      {
        path: 'profile/:id',
        element: <Profile />
      }
    ]
  },
  {
    path: '/',
    element: <Login />,
    ErrorBoundary: ErrorFallback,
  },
  {
    path: '/login',
    element: <Login />,
    ErrorBoundary: ErrorFallback,
  },
  {
    path: 'reset-password/',
    element: <ResetPassword />,
    ErrorBoundary: ErrorFallback,
  },
  {
    path: '/auth/setup',
    element: <RequireInviteToken />,
    ErrorBoundary: ErrorFallback,
  },
  {
    path: '/set-password',
    element: <SetPassword />,
    ErrorBoundary: ErrorFallback,
  },
  {
    path: '*',
    element: <Navigate replace to='/' />,
  }
])

const LoggedOut = () => <RouterProvider router={loggedOutRouter} />

export default LoggedOut
